import * as R from 'ramda'

export const hasOf = R.curry(
  (type, prop) => R.compose(R.is(type), R.prop(prop))
)
